import { AuthService } from './auth.service';

import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

export const authGuard = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return new Promise(resolve => {
    authService
      .initAuth()
      .then(() => {
        if (authService.authenticated()) {
          resolve(true);
        } else {
          router.navigate(['/home']);
          resolve(false);
        }
      })
      .catch(() => {
        resolve(false);
      });
  });
};
